/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Box from "components/generals/Box";
import ResourceTable from "components/tables/ResourceTable";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { ResourceInterface, QueryResultInterface } from "medicalsystem-shared";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Content component for displaying and managing medical resources.
 * Shows a table of all resources (equipment, rooms, etc.) with search and pagination functionality.
 * @returns {React.ReactElement} The resource data content component
 */
const ResourceDataContent: React.FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [resourceList, setResourceList] = useState<ResourceInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const { t } = useTranslation();
  const [filterModel, setFilterModel] = useState<string>("");

  useEffect(() => {
    console.log("sending request...");
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.RESOURCE_GET_ALL}?${nameParam}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetResourceHandler, "GET");
  }, [page, pageSize, filterModel]);

  const onGetResourceHandler = (resourcesResponse: QueryResultInterface<ResourceInterface>) => {
    setResourceList(resourcesResponse.results);
    setRowsTotal(resourcesResponse.total);
    setPageTotal(Math.ceil(resourcesResponse.total / pageSize));
  };

  return (
    <Box>
      <ResourceTable
        modelList={resourceList}
        setModelList={setResourceList}
        canSearchPlaceholder={t("resourceTable.searchResource")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ResourceDataContent;
